//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "scoring-sup-detail",
  data(){
    return{
      ratingId:null,
      scoringId:null,
      scoringDetailId:null,
      planObj:{},
      scoreObj:{},
      scoreFields:{},
      userScoreStatus:null,//评分状态
      readOnly:false
    }
  },
  methods:{
    validScore(field){
      if(this.scoreFields[field.fieldName]){
        this.scoreFields[field.fieldName] = Math.floor(this.scoreFields[field.fieldName] * 100) / 100;
      }
      if(field.maxScore && this.scoreFields[field.fieldName] && this.scoreFields[field.fieldName] > field.maxScore){
        this.$vux.toast.text(`该评分项最大分值为${field.maxScore},请重新填写分值`);
        this.scoreFields[field.fieldName] = null;
        return;
      }
      if(field.minScore && this.scoreFields[field.fieldName] && this.scoreFields[field.fieldName] < field.minScore){
        this.$vux.toast.text(`该评分项最小分值为${field.minScore},请重新填写分值`);
        this.scoreFields[field.fieldName] = null;
      }
      let allScore = 0;
      if (this.planObj.dynamicForm.dynamicTables[0]) {
        for (let i = 0; i < this.planObj.dynamicForm.dynamicTables[0].dynamicFields.length; i++) {
          if (this.scoreFields[this.planObj.dynamicForm.dynamicTables[0].dynamicFields[i].fieldName]) {
            allScore += Number(this.scoreFields[this.planObj.dynamicForm.dynamicTables[0].dynamicFields[i].fieldName]);
          }
        }
        this.$set(this.scoreFields,'total_score',allScore);
      }
    },
    //获取评分数据
    getRatingDto(){
      this.$loadingShow();
      this.$get(`api/scoring-scheme-detail/${this.ratingId}`).then((data) => {
        if(data){
          this.planObj = data;
          if(this.planObj.dynamicForm && this.planObj.dynamicForm.dynamicTables && this.planObj.dynamicForm.dynamicTables[0] && this.planObj.dynamicForm.dynamicTables[0].dynamicFields){
            this.planObj.dynamicForm.dynamicTables[0].dynamicFields.forEach((field) => {
              if(field.config){
                let config = JSON.parse(field.config);
                let rule = '';
                if(config.rules){
                  config.rules.forEach((str) => {
                    rule += str;
                  })
                }
                field.ruleStr = rule;
                field.maxScore = config.maxScore;
                field.minScore = config.minScore;
              }
            })
          }
          this.getSupScore();
        }
        this.$get(`api/person/current`).then((res) => {
          this.planObj.scoringDetails.forEach((item) => {
            if(item.scoringPerson.person.id === res.id && item.scoringObject.id == this.scoringId){
              this.userScoreStatus = item.status;
            }
          });
          this.$loadingHide();
        }).catch(() => {
          this.$loadingHide();
        });
      }).catch(() => {
        this.$loadingHide();
      });
    },
    //  获取供应商得分
    getSupScore(){
      this.$get(`api/scoring-value/${this.scoringId}/${this.scoringDetailId}/current`).then((data) => {
        this.scoreObj = data;

        if(this.scoreObj.data[this.planObj.dynamicForm.dynamicTables[0].tableName]){
          if(this.scoreObj.data[this.planObj.dynamicForm.dynamicTables[0].tableName].length == 1){
            this.scoreFields = JSON.parse(JSON.stringify(this.scoreObj.data[this.planObj.dynamicForm.dynamicTables[0].tableName][0]));
          }else{
            this.scoreObj.data[this.planObj.dynamicForm.dynamicTables[0].tableName].forEach((data) =>{
              if(data.person == this.scoreObj.data.personId){
                this.scoreFields = JSON.parse(JSON.stringify(data));
              }
            })
          }
        }
        if(this.planObj){
          this.initDynamicTableData(this.planObj.dynamicForm.dynamicTables[0].dynamicFields);
        }
      });
    },
    /**初始化数据*/
    initDynamicTableData(dynamicFields) {
      const dynamicField = dynamicFields;
      for (let i = 0; i < dynamicField.length; i++) {
        if (dynamicField[i].fieldName && dynamicField[i]['config']) {
          if(!this.scoreFields[dynamicField[i].fieldName]){
            this.scoreFields[dynamicField[i].fieldName] = JSON.parse(dynamicField[i]['config'])['initScore'];
          }
        }
      }
    },
    //  提交分数
    submitScore(){
      if(this.planObj.dynamicForm && this.planObj.dynamicForm.dynamicTables && this.planObj.dynamicForm.dynamicTables[0] && this.planObj.dynamicForm.dynamicTables[0].dynamicFields){
        for(let i=0;i<this.planObj.dynamicForm.dynamicTables[0].dynamicFields.length;i++){
          let fieldName = this.planObj.dynamicForm.dynamicTables[0].dynamicFields[i].fieldName;
          if(!this.scoreFields[fieldName] && this.scoreFields[fieldName] !== 0){
            this.$vux.toast.text(`请填写${this.planObj.dynamicForm.dynamicTables[0].dynamicFields[i].name}项得分`);
            return;
          }
        }
        let submitScoreObj = JSON.parse(JSON.stringify(this.scoreObj));
        submitScoreObj.data[this.planObj.dynamicForm.dynamicTables[0].tableName] = this.scoreFields;
        this.$loadingShow();
        this.$put('api/scoring-value',submitScoreObj).then(() => {
          this.$vux.toast.text('评分成功');
          this.$router.go(-1);
          this.$loadingHide();
        }).catch(() => {
          this.$loadingHide();
        })
      }
    },
    changeScoreShow(data){
      if(data.scoreShow){
        this.$set(data,'scoreShow',false);
        return;
      }
      this.$set(data,'scoreShow',true);
    }
  },
  mounted(){
    this.ratingId = this.$route.params.ratingId;
    this.scoringId = this.$route.params.scoringId;
    this.scoringDetailId = this.$route.params.scoringDetailId;
    this.getRatingDto();
  }
}



// WEBPACK FOOTER //
// ./src/page/sources/source-score/scoring-sup-detail.vue